import React, { FC, useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import useService from '../../hooks/service.hook';
import ChatService from '../../services/chat.service';
import { CHAT_UI_URL } from '../../constants/server.constants';
import ChatLoadingScreen from '../../components/chat-loading/ChatLoadingScreen';
import { getCachedEmbedToken, setCachedEmbedToken } from '../../helpers/chatEmbedToken';
import './chat.page.css';

const ChatPage: FC = () => {
  const chatService = useService(ChatService);

  const [embedUrl, setEmbedUrl] = useState<string>('');
  const [iframeReady, setIframeReady] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const pageClass = window.localStorage.getItem('sidedrawer') ? 'page-full' : 'page';

  useEffect(() => {
    const cached = getCachedEmbedToken();
    if (cached) {
      setEmbedUrl(`${CHAT_UI_URL}/embed/channels?token=${encodeURIComponent(cached)}`);
      return;
    }

    chatService
      .getEmbedToken()
      .then((response: any) => {
        const { token } = response.data.data;
        setCachedEmbedToken(token);
        setEmbedUrl(`${CHAT_UI_URL}/embed/channels?token=${encodeURIComponent(token)}`);
      })
      .catch(() => {
        setError('Unable to load chats.');
      });
  }, []);

  if (error) {
    return (
      <div className={pageClass} id="page">
        <div style={{ padding: 20 }}>
          <Alert severity="error">{error}</Alert>
        </div>
      </div>
    );
  }

  return (
    <div className={pageClass} id="page">
      <div className="chat-page-container">
        {/* Loading screen sits as an overlay until the iframe fires onLoad */}
        {!iframeReady && <ChatLoadingScreen overlay />}

        {embedUrl && (
          <iframe
            src={embedUrl}
            title="My Chats"
            allow="clipboard-write"
            onLoad={() => setIframeReady(true)}
            style={{ opacity: iframeReady ? 1 : 0, transition: 'opacity 0.4s ease' }}
          />
        )}
      </div>
    </div>
  );
};

export default ChatPage;
